module.exports = __webpack_public_path__ + "img/more1.e549c67a.png";